import { render, staticRenderFns } from "./stock-history-table.vue?vue&type=template&id=c67d182e&"
import script from "./stock-history-table.vue?vue&type=script&lang=js&"
export * from "./stock-history-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports